import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HelpService } from '/app/services/help/help.service';

import { UsersService } from '../../services/usuers.service';
import { User } from '/app/users/models/users.model';

import { FormGroup } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ConfirmDialogComponent } from '/app/components/confirm/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-users-details',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCheckboxModule
],

  templateUrl: './users-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './users-details.component.scss'
})
export class UsersDetailsComponent implements OnInit {

  @Output() closed = new EventEmitter<void>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() showError = new EventEmitter<string>();

  @Output() showSuccess = new EventEmitter<string>();
  // TABLA
  showEmail: boolean = true;
  showName: boolean = true;
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<User>([]);
  totalUsers = 0;
  pageSize = 100;

  // FORMULARIO NUEVO USUARIO
  isAddingUser = false;
  userForm!: FormGroup;

  constructor(
    private usersService: UsersService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private helpService: HelpService
  ) { }

  showHelp(): void {
    this.helpService.startTour(this.helpService.getUsersDetailsHelpSteps());
  }

  ngOnInit(): void {
    this.initForm();
    this.updateDisplayedColumns();
    this.loadUsers();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  initForm() {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      name: ['', Validators.required],
      familyName: ['', Validators.required]
    });
  }

  updateDisplayedColumns() {
    this.displayedColumns = [];
    if (this.showEmail) {
      this.displayedColumns.push('email');
    }
    if (this.showName) {
      this.displayedColumns.push('fullName');
    }
    this.displayedColumns.push('actions');
  }

  onShowEmailChange() {
    if (!this.showEmail && !this.showName) {
      this.showName = true;
    }
    this.updateDisplayedColumns();
  }

  onShowNameChange() {
    if (!this.showName && !this.showEmail) {
      this.showEmail = true;
    }
    this.updateDisplayedColumns();
  }

  loadUsers(page: number = 0): void {
    this.usersService.getUsers(page, this.pageSize).subscribe({
      next: (resp: any) => {
        // Verificar si la respuesta tiene la estructura esperada
        if (resp && resp.content) {
          this.dataSource.data = resp.content;
          this.totalUsers = resp.totalElements || resp.content.length;
        } else if (Array.isArray(resp)) {
          // Si la respuesta es directamente un array
          this.dataSource.data = resp;
          this.totalUsers = resp.length;
        
        } else {
          console.warn('Estructura de respuesta inesperada:', resp);
          this.dataSource.data = [];
          this.totalUsers = 0;
        }
      },
      error: (error) => {
        console.error('Error al cargar usuarios:', error);
        this.dataSource.data = [];
        this.totalUsers = 0;

        if (error.status === 403) {
          this.onShowError('❌ No tienes permisos para ver los usuarios.');
        } else if (error.status === 404) {
          this.onShowError('❌ Servicio de usuarios no encontrado.');
        } else {
          this.onShowError('❌ Error al cargar los usuarios: ' + (error.message || 'Error desconocido'));
        }
      },
    });
  }





  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.loadUsers(event.pageIndex);
  }

  // ======================
  // AÑADIR USUARIO
  // ======================
  startAddUser() {
    this.isAddingUser = true;
    this.userForm.reset();
  }

  // saveUser() {
  //   if (this.userForm.invalid) return;
  //   this.isAddingUser = false;
  //   this.loadUsers();
  // }

  saveUser() {
    if (this.userForm.invalid) {
      this.onShowError("❌ Completa todos los campos correctamente.");
      return;
    }

    const newUser = this.userForm.value;
    this.usersService.createUser(newUser).subscribe({
      next: () => {
        this.onShowSuccess("✅ Usuario creado correctamente");
        this.isAddingUser = false;
        this.loadUsers();      // recargar lista
      },
      error: (err) => {
        let msg = '❌ Error al crear el usuario.';

        if (err.status === 409) {
          msg = "❌ Ya existe un usuario con ese email.";
        }

        this.onShowError(msg);
      }
    });
  }


  cancelAddUser() {
    this.isAddingUser = false;
  }

  closeDetails(): void {
    this.closed.emit();
  }

  delete(user: User) {
  }

  onEnableUser(user: User) {
    this.usersService.enableUser(user.id).subscribe({
      next: () => {
        this.onShowSuccess('✅ Usuario habilitado:');
      },
      error: (err) => {
        this.loadUsers();
        this.onShowError('❌ Error al actualizar el monitor:');
      }
    });
  }

  onDesableUser(user: User) {
    this.usersService.disableUser(user.id).subscribe({
      next: () => {
        this.onShowSuccess('✅ suario Desabilitado:');
      },
      error: (err) => {
        this.loadUsers();
        this.onShowError('❌ Error al Desabilitado el usuario:');
      }
    });
  }

  onToggleChange(isActive: boolean, user: User) {
    const previousValue = user.active; // valor real antes del toggle
    const action = isActive ? 'Activar' : 'Desactivar';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: `${action} Usuario`,
        message: `¿Estás seguro de ${action.toLowerCase()} a ${user.name} ${user.familyName}?`,
        confirmText: `Sí, ${action}`,
        cancelText: 'Cancelar',
        icon: 'exit',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (!result) {
        this.loadUsers();
        user.active = previousValue;
        return;
      }


      user.active = isActive;

      const request = isActive
        ? this.usersService.enableUser(user.id)
        : this.usersService.disableUser(user.id);

      request.subscribe({
        next: () => {
          this.onShowSuccess(`Usuario ${isActive ? 'activado' : 'desactivado'} correctamente`);
        },
        error: () => {
          // ❌ API falló → revertir toggle
          user.active = previousValue;
          this.onShowError(`Error al ${action.toLowerCase()} el usuario`);
        }
      });

    });
  }

  onShowError(message: string): void {
    this.showError.emit(message);
  }

  onShowSuccess(message: string): void {
    this.showSuccess.emit(message);
  }




}
